
import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from "@/components/ui/button";

interface PromptContentProps {
  content: string;
  onClick?: (e: React.MouseEvent) => void;
}

const PromptContent: React.FC<PromptContentProps> = ({ content, onClick }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  // Calculate preview length based on content
  const previewLength = content.length > 300 ? 150 : (content.length > 150 ? 100 : 80);
  const previewContent = !isExpanded && content.length > previewLength 
    ? content.substring(0, previewLength) + "..." 
    : content;

  const handleExpandClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  return (
    <div 
      className="bg-secondary/40 dark:bg-secondary/20 rounded-lg p-3 mb-3 relative"
      onClick={(e) => {
        // Only handle the click if onClick is provided and the click wasn't on the expand button
        if (onClick && !(e.target as HTMLElement).closest('button')) {
          onClick(e);
        }
      }}
    >
      <pre className="text-sm whitespace-pre-wrap break-words font-mono max-w-full">{previewContent}</pre>
      {content.length > previewLength && (
        <Button 
          variant="ghost" 
          size="sm" 
          className="mt-1 p-0 h-auto flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground" 
          onClick={handleExpandClick}
        >
          {isExpanded ? (
            <>
              <ChevronUp className="h-3 w-3" />
              <span>Show less</span>
            </>
          ) : (
            <>
              <ChevronDown className="h-3 w-3" />
              <span>Show more</span>
            </>
          )}
        </Button>
      )}
    </div>
  );
};

export default PromptContent;
